import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/wealthLevel',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-wealthLevel-index" */ '~/pages/WealthLevel/pages/index'
        )
    ),
  },
  {
    path: '/wealthLevel/level',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-wealthLevel-level" */ '~/pages/WealthLevel/pages/level'
        )
    ),
  },
  {
    path: '/wealthLevel/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-wealthLevel-detail" */ '~/pages/WealthLevel/pages/detail'
        )
    ),
  },
  {
    path: '/wealthLevel/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-wealthLevel-rule" */ '~/pages/WealthLevel/pages/rule'
        )
    ),
  },
] as RouteConfig[]
